<template>
  <div>
    <!-- Botão de Sessão sempre visível -->
    <vs-card v-if="precisaLoginBling">
      <div class="text-center">
        <vs-button color="primary" @click="iniciaSessao">
          Iniciar Sessão
        </vs-button>
      </div>
    </vs-card>

    <!-- Conteúdo exibido quando há código da sessão -->
    <div v-if="blingValido" class="vx-row">
      <!-- Produtos -->
      <div class="vx-col sm:w-1/3 w-full">
        <vs-card>
          <div slot="header">
            <h3 class="text-center">Produtos</h3>

            <!-- Barra de pesquisa para produtos -->
            <div class="search-container mb-4">
              <div class="vx-row">
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" name="searchSku" id="searchSku" placeholder="Buscar por SKU"
                    v-model="searchSku" val-icon-danger="clear" icon-no-border />
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button class="w-full" color="primary" @click="buscarProdutosPorSku">
                    <i class="fa fa-search mr-2"></i>
                  </vs-button>
                </div>
              </div>

              <!-- Botão para voltar à lista original -->
              <div v-if="isSearchActive" class="mt-2">
                <vs-button color="dark" type="border" size="small" @click="voltarListaOriginal">
                  <i class="fa fa-arrow-left mr-2"></i> Voltar à lista original
                </vs-button>
              </div>
            </div>

            <div v-if="produtos.length === 0">
              <vs-alert style="height: auto" active="true" color="danger">
                Nenhum produto encontrado ou pendente de integração no momento.
              </vs-alert>
            </div>
            <div v-else>
              <table class="table table-bordered">
                <tr v-for="item in produtos" :key="item.idProduto">
                  <td width="100">
                    <img :src="getImagem(item)" width="100" />
                  </td>
                  <td>
                    <p class="product-category">
                      <b>{{ item.nome }}</b>
                    </p>
                    <p v-if="item.codigo" class="product-category">
                      <b>SKU:</b> {{ item.codigo }}
                    </p>
                    <div v-if="item.variacoes && item.variacoes.length > 0">
                      <b>Variações:</b>
                      <div v-for="(variacao, index) in item.variacoes" :key="index">
                        {{ variacao.variacao }} {{ variacao.valor }}
                        <span v-if="variacao.sku">
                          - SKU {{ variacao.sku }}</span>
                        <span v-if="variacao.quantidade !== undefined">
                          (Qtd: {{ variacao.quantidade }})</span>
                      </div>
                    </div>
                    <b>Produto Bling: </b>

                    <vs-button class="mb-4 ml-3" :color="item.idProdutoBling ? 'warning' : 'dark'" @click="
                      forceCadastroClick('cadastrarProduto', item.idProduto)
                      ">
                      {{
                        item.idProdutoBling
                          ? "Atualizar Produto"
                          : "Adicionar Produto"
                      }}
                    </vs-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </vs-card>
      </div>

      <!-- Encomendas -->
      <div class="vx-col sm:w-2/3 w-full">
        <vs-card>
          <div slot="header">
            <h3 class="text-center">Encomendas</h3>
            <div class="vx-row p-2">
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" name="idEncomenda" id="idEncomenda" placeholder="id Encomenda"
                  v-model="idEncomenda" val-icon-danger="clear" danger-text="Preencha este Campo" icon-no-border />
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button class="mb-4 ml-3 w-full" color="dark" @click="buscarEncomendas()">
                  <i class="fa fa-search mr-2"></i>
                </vs-button>
              </div>
            </div>

            <vs-dropdown v-if="encomendasToShow.length" vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">
                  {{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
                  {{ encomendasToShow.length }} de {{ qtdTotal }}
                </span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 5">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>100</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 25">
                  <span>250</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 50">
                  <span>500</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-pagination :total="qtdPaginas" v-model="paginaAtual"></vs-pagination>
            <input v-if="encomendasToShow.length > 0" type="checkbox" v-model="selecionaTodos" id="checkbox-1"
              @click="selecionarTodos()" />
            <label for="checkbox-1" class="ml-4 mt-3">Selecionar todos</label>
            <vs-button v-if="selecionado.length > 0" color="primary" type="gradient" class="mb-2 ml-6"
              @click="enviarVarias">
              Sincronizar Varias
            </vs-button>
            <vs-alert color="primary" icon="🔄" active="true" v-if="sincronizandoEncomendas" class="mb-2">
              Sincronizando encomendas, por favor aguarde...
            </vs-alert>
            <table class="table table-bordered" v-if="encomendasToShow.length > 0">
              <tr>
                <th></th>
                <th>Id</th>
                <th>Data</th>
                <th>Cliente</th>
                <th>Itens</th>
                <th>Status</th>
                <th>Ação</th>
              </tr>
              <tr v-for="item in encomendasToShow" :key="item.idEncomenda">
                <td>
                  <input type="checkbox" v-model="selecionado" :value="item.idEncomenda" />
                </td>
                <td>{{ item.idEncomenda }}</td>
                <td>{{ FormData(item.createdAt) }}</td>
                <td>
                  {{ item.nome }} <br />
                  {{ item.email }} <br />
                  {{ item.celular }}
                </td>
                <td>{{ item.itens.length }}</td>
                <td>{{ item.nomeStatus }}</td>
                <td>
                  <vs-button radius v-tooltip="'Sincronizar'" color="success" type="gradient" icon-pack="fa"
                    icon="fa-refresh" class="d-inline" @click="
                      sincronizarEncomendaClick(
                        'SincronizarEncomenda',
                        item.idEncomenda
                      )
                      "></vs-button>
                </td>
              </tr>
            </table>
          </div>
        </vs-card>
      </div>
    </div>

    <!-- Modal de resultado da sincronização (CSS/JS puro) -->
    <div id="syncModal" class="custom-modal" v-show="syncModalVisible">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Resultado da Sincronização</h3>
          <span class="close-button" @click="closeSyncModal">&times;</span>
        </div>
        <div class="modal-body">
          <div v-if="syncModalErrors.length > 0">
            <p>{{ syncModalMessage }}</p>
            <ul class="error-list">
              <li v-for="error in syncModalErrors" :key="error.idEncomenda">
                Encomenda {{ error.idEncomenda }}: {{ error.error }}
              </li>
            </ul>
          </div>
          <div v-else>
            <p>{{ syncModalMessage }}</p>
          </div>
        </div>
        <div class="modal-footer">
          <button class="modal-button primary" @click="closeSyncModal">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from "./../../../services";
import vSelect from "vue-select";
import moment from "moment";
import jwt from "jsonwebtoken";
import swal from "sweetalert";

export default {
  data() {
    return {
      precisaLoginBling: false,
      selecionaTodos: false,
      blingValido: false,
      bling: {
        code: null,
        state: null,
      },
      sincronizandoEncomendas: false,
      produtos: [],
      produtosOriginais: [],
      produtosBling: [],
      encomendasToShow: [],
      qtdPaginas: 0,
      paginaAtual: 1,
      itemsPerPage: 10,
      qtdTotal: 0,
      idEncomenda: null,
      selecionado: [],
      decoded: null,
      syncModalVisible: false,
      syncModalMessage: "",
      syncModalErrors: [],
      searchSku: "",
      isSearchActive: false,
      searchLoading: false,
    };
  },
  watch: {
    paginaAtual() {
      this.buscarEncomendas();
    },
    itemsPerPage() {
      this.buscarEncomendas();
    },
    syncModalVisible(newValue) {
      if (newValue) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
  },
  mounted() {
    this.verificarSessaoBling();
    this.getDecoded();
    this.getParamsBling();
    this.checkStatusBling();

    if (this.bling.code) {
      this.finalizarLoginBling();
    } else {
      this.buscarProdutosPorSku();
    }

    document.addEventListener("click", (e) => {
      const modal = document.getElementById("syncModal");
      if (e.target === modal) this.closeSyncModal();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.syncModalVisible) {
        this.closeSyncModal();
      }
    });
  },
  methods: {
    getDecoded() {
      const token = localStorage.getItem("user-token");
      if (token) this.decoded = jwt.decode(token);
    },

    async verificarSessaoBling() {
      try {
        const idEmpresa = this.decoded && this.decoded.idEmpresa;
        if (!idEmpresa) return;

        const res = await service.post("Bling", "token-info", { idEmpresa });
        this.precisaLoginBling = res.data === true;
      } catch (err) {
        console.error("Erro ao verificar sessão Bling:", err);
        this.precisaLoginBling = true;
      }
    },

    async checkStatusBling() {
      try {
        const idEmpresa = this.decoded && this.decoded.idEmpresa;
        const res = await service.post("Bling", "token-info", { idEmpresa });
        const precisaLogin = res.data === true;
        this.blingValido = !precisaLogin;
        if (!precisaLogin) {
          this.blingValido = true;
          this.buscarEncomendas();
          this.getProdutos();
        }
      } catch (e) {
        console.error("Erro ao verificar token do Bling:", e);
        this.blingValido = false;
      }
    },

    async iniciaSessao() {
      try {
        const idEmpresa = this.decoded && this.decoded.idEmpresa;
        if (!idEmpresa) return;

        const res = await service.post("Bling", "token-info", { idEmpresa });
        const precisaLogin = res.data === true;

        if (precisaLogin || this.bling.code) {
          if (this.bling.code) return await this.finalizarLoginBling();

          const clientId =
            this.decoded &&
            this.decoded.blingData &&
            this.decoded.blingData.clientId;

          const state = "bling_" + Date.now();
          localStorage.setItem("blingAction", "buscaProdutos");
          window.location.href = `https://api.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=${clientId}&state=${state}`;
        } else {
          this.blingValido = true;
          this.buscarEncomendas();
        }
      } catch (err) {
        console.error("Erro ao iniciar sessão Bling:", err);
        this.blingValido = false;
      }
    },

    async finalizarLoginBling() {
      try {
        const idEmpresa = this.decoded && this.decoded.idEmpresa;
        if (!this.bling.code || !idEmpresa) return;

        const obj = {
          code: this.bling.code,
          idEmpresa,
        };

        const res = await service.post("Bling", "login", obj);

        if (res.data && res.data.status === "success") {
          this.blingValido = true;
          this.bling.code = null;
          const action = this.getAction();
          if (action.action === "buscaProdutos") this.getProdutos();
          if (action.action === "cadastrarProduto") {
            const item = this.produtos.find((x) => x.idProduto == action.value);
            if (item) this.forceCadastro(item);
          }
          if (action.action === "SincronizarEncomenda") {
            this.sincronizarEncomenda(action.value);
          }
        }
      } catch (err) {
        swal("ops!", err, "error");
        this.blingValido = false;
      }
    },

    getParamsBling() {
      const url = new URL(window.location.href);
      this.bling.code = url.searchParams.get("code");
      this.bling.state = url.searchParams.get("state");
    },

    getAction() {
      return {
        action: localStorage.getItem("blingAction"),
        value: localStorage.getItem("blingValue"),
      };
    },

    saveAction(action, value) {
      localStorage.setItem("blingAction", action);
      localStorage.setItem("blingValue", value);
    },

    showSyncModal() {
      this.syncModalVisible = true;
    },

    closeSyncModal() {
      this.syncModalVisible = false;
      this.buscarEncomendas();
    },

    async buscarProdutosPorSku() {
      if (!this.searchSku.trim()) {
        this.voltarListaOriginal();
        return;
      }

      this.searchLoading = true;
      this.$vs.loading();

      try {
        if (!this.isSearchActive && this.produtos.length > 0) {
          this.produtosOriginais = [...this.produtos];
        }

        const objSend = {
          idEmpresa: this.decoded.idEmpresa,
          sku: this.searchSku.trim(),
        };

        const response = await service.post(
          "Bling",
          "ListarProdutosBling",
          objSend
        );

        if (response.data && response.data.produtos) {
          this.produtos = [];
          response.data.produtos.forEach((element) => {
            element.showSelect = false;
            if (!Array.isArray(element.variacoes)) {
              try {
                element.variacoes = JSON.parse(element.variacoes);
              } catch (e) {
                console.warn(
                  "Falha ao interpretar 'variacoes':",
                  element.variacoes
                );
                element.variacoes = [];
              }
            }
            this.produtos.push(element);
          });

          this.isSearchActive = true;
          this.saveStorageProdutos();
        }
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
        this.$vs.notify({
          position: "top-center",
          title: "Erro",
          text: "Falha ao buscar produtos por SKU. Tente novamente.",
          color: "danger",
        });
      } finally {
        this.searchLoading = false;
        this.$vs.loading.close();
      }
    },

    voltarListaOriginal() {
      this.searchSku = "";
      this.isSearchActive = false;
      this.getProdutos();
    },

    getImagem(item) {
      if (
        item &&
        item.midia &&
        item.midia.imagens &&
        item.midia.imagens.imagensURL &&
        item.midia.imagens.imagensURL.length > 0
      ) {
        return item.midia.imagens.imagensURL[0].link;
      }
      return "";
    },

    cancelarEncomenda(idEncomenda) {
      this.$vs.loading();
      const objSend = {
        idEncomenda,
        blingData: this.bling,
      };

      service
        .post("Bling", "cancelarEncomendaBling", objSend)
        .then((res) => {
          this.$vs.loading.close();
          if (res.data && res.data.success) {
            this.$vs.notify({
              position: "top-center",
              title: "Sucesso",
              text: res.data.message || "Encomenda cancelada com sucesso.",
              color: "success",
            });
            this.encomendasToShow = this.encomendasToShow.filter(
              (item) => item.idEncomenda !== idEncomenda
            );
          } else {
            this.$vs.notify({
              position: "top-center",
              title: "Atenção",
              text: res.data.message || "Falha ao cancelar a encomenda.",
              color: "danger",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Erro",
            text: "Erro ao cancelar a encomenda.",
            color: "danger",
          });
        });
    },

    selecionarTodos() {
      this.encomendasToShow.forEach((element) => {
        this.selecionado.push(element.idEncomenda);
      });
    },

    enviarVarias() {
      this.sincronizarEncomendaClick("SincronizarEncomenda", this.selecionado);
    },

    showSelect(item) {
      item.showSelect = true;
    },

    getVariacao(variacao) {
      return variacao.variacao.substring(0, 1) + variacao.valor;
    },

    FormData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm");
    },

    integraBling() {
      if (!this.decoded || !this.decoded.blingData) {
        this.$vs.notify({
          position: "top-center",
          title: "Atenção",
          text: "Não há dados de configuração do Bling no token.",
          color: "danger",
        });
        return;
      }
      let client_id = this.decoded.blingData.clientId;
      window.location.href = `https://api.bling.com.br/Api/v3/oauth/authorize?response_type=code&client_id=${client_id}&state=fb8fa559bc0125f291641aeb4923ce26`;
    },

    sincronizarEncomendaClick(action, item) {
      localStorage.removeItem("blingAction");
      localStorage.removeItem("blingValue");
      this.saveAction(action, item);
      this.integraBling();
    },

    forceCadastroClick(action, itemId) {
      const item = this.produtos.find((x) => x.idProduto === itemId);
      if (this.blingValido) {
        this.forceCadastro(item);
      } else {
        this.saveAction(action, itemId);
        this.integraBling();
      }
    },

    saveStorageProdutos() {
      localStorage.setItem(
        "blingProdutos",
        JSON.stringify({
          produtos: this.produtos,
          produtosBling: this.produtosBling,
        })
      );
    },

    async sincronizarEncomenda(idEncomenda) {
      this.sincronizandoEncomendas = true;
      this.$vs.loading();
      const objSend = {
        idEncomenda,
        blingData: this.bling,
      };

      try {
        const res = await service.post(
          "Bling",
          "sincronizarEncomendaBling",
          objSend
        );

        if (res.data && res.data.success) {
          this.syncModalMessage =
            res.data.message || "Encomenda sincronizada com sucesso";
          this.syncModalErrors = [];
          this.showSyncModal();
        } else {
          if (
            res.data &&
            res.data.syncErrors &&
            res.data.syncErrors.length > 0
          ) {
            this.syncModalMessage =
              "Algumas encomendas não foram sincronizadas.";
            this.syncModalErrors = res.data.syncErrors.map((err) => ({
              idEncomenda: err.idEncomenda,
              error: err.error.includes("status code 400")
                ? "Falha na sincronização. Verifique os dados enviados."
                : err.error,
            }));
          } else {
            this.syncModalMessage = "Falha ao sincronizar a encomenda.";
            this.syncModalErrors = [];
          }
          this.showSyncModal();
        }
      } catch (error) {
        this.syncModalMessage = "Erro ao sincronizar a encomenda.";
        this.syncModalErrors = [];
        this.showSyncModal();
      } finally {
        this.sincronizandoEncomendas = false;
        this.$vs.loading.close();
      }
    },

    async forceCadastro(item) {
      this.$vs.loading();

      const objSend = {
        ...item,
        idEmpresa: this.decoded.idEmpresa,
      };

      try {
        if (item.idProdutoBling) {
          await service.put("Bling", "AtualizarProdutoBling", objSend);
          this.$vs.notify({
            position: "top-center",
            title: "Sucesso",
            text: "Produto atualizado com sucesso.",
            color: "success",
          });
        } else {
          const res = await service.post(
            "Bling",
            "AdicionarProdutoBling",
            objSend
          );
          this.$vs.notify({
            position: "top-center",
            title: "Sucesso",
            text: "Produto adicionado com sucesso.",
            color: "success",
          });
          item.idProdutoBling = res.data.idProdutoBling;
        }

        this.saveStorageProdutos();
      } catch (e) {
        let msg =
          (e &&
            e.response &&
            e.response.data &&
            e.response.data.errorMessage) ||
          (e &&
            e.response &&
            e.response.data &&
            JSON.stringify(e.response.data)) ||
          (e && e.message) ||
          "Erro desconhecido";

        this.$vs.notify({
          position: "top-center",
          title: "Erro",
          text: msg,
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    salvaProdutoBling(item) {
      this.$vs.loading();
      var objSend = { ...item };
      service
        .post("Bling", "SalvarProdutoBling", objSend)
        .then(() => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: "Produto Salvo com sucesso",
            color: "success",
          });
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },

    getProdutosFromStorage() {
      if (localStorage.getItem("blingProdutos")) {
        this.produtos = JSON.parse(
          localStorage.getItem("blingProdutos")
        ).produtos;
        return;
      }
    },

    getProdutos() {
      this.searchSku = "";
      this.produtosOriginais = [];
      this.produtos = [];
      this.$vs.loading();

      const objSend = {
        idEmpresa:
          this.decoded && this.decoded.idEmpresa
            ? this.decoded.idEmpresa
            : null,
        sku: "",
      };

      service
        .post("Bling", "ListarProdutosBling", objSend)
        .then((res) => {
          this.$vs.loading.close();
          const produtosRes = res.data.produtos || [];

          this.produtos = produtosRes.map((element) => {
            if (!Array.isArray(element.variacoes)) {
              try {
                element.variacoes = JSON.parse(element.variacoes);
              } catch (e) {
                console.warn(
                  "Falha ao interpretar 'variacoes':",
                  element.variacoes
                );
                element.variacoes = [];
              }
            }
            return {
              ...element,
              showSelect: false,
            };
          });
        })
        .catch((e) => {
          this.$vs.loading.close();
          let msg =
            (e &&
              e.response &&
              e.response.data &&
              e.response.data.errorMessage) ||
            (e &&
              e.response &&
              e.response.data &&
              JSON.stringify(e.response.data)) ||
            (e && e.message) ||
            "Erro desconhecido";

          this.$vs.notify({
            position: "top-center",
            title: "Erro",
            text: msg,
            color: "danger",
          });
        });
    },

    buscarEncomendas() {
      this.$vs.loading();
      var objSend = {
        idStatus: [{ id: 3 }, { id: 5 }, { id: 6 }, { id: 8 }],
        qtdPorPagina: this.itemsPerPage,
        pagina: this.paginaAtual,
      };
      if (this.idEncomenda) {
        objSend.idEncomenda = this.idEncomenda;
        objSend.pagina = 1;
      }
      service
        .post("Bling", "ListarEncomendasBling", objSend)
        .then((res) => {
          this.encomendasToShow = [];
          res.data.encomendas.forEach((element) => {
            if (typeof element.itens === "string") {
              try {
                element.itens = JSON.parse(element.itens);
              } catch (e) {
                console.error("Erro ao converter JSON:", e, element.itens);
                element.itens = [];
              }
            }
            this.encomendasToShow.push(element);
          });
          this.qtdTotal = res.data.qtd;
          this.qtdPaginas = this.qtdTotal / this.itemsPerPage;
          if (this.qtdPaginas % 1 !== 0) this.qtdPaginas++;
          this.qtdPaginas = parseInt(this.qtdPaginas);
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-center",
            title: "Atenção",
            text: e,
            color: "danger",
          });
        });
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>

<style>
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
}

.table-bordered tr td {
  padding: 2px;
  padding-left: 10px;
}

.table-bordered tr:nth-child(2n) {
  background: #efefef;
}

/* Estilos para a barra de pesquisa */
.search-container {
  margin-bottom: 15px;
}

/* Estilos para a modal personalizada */
.custom-modal {
  display: flex;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fff;
  margin: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 600px;
  animation: modalFadeIn 0.3s;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f8f9fa;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-button {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.2s;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #e9e9e9;
  text-align: right;
  background-color: #f8f9fa;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.modal-button.primary {
  background-color: #1976d2;
  color: white;
}

.modal-button.primary:hover {
  background-color: #1565c0;
}

.error-list {
  margin-top: 10px;
  padding-left: 20px;
  color: #d32f2f;
}

body.modal-open {
  overflow: hidden;
}
</style>

<style scoped>
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
</style>
